(function () {
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = null;

  function qsa(root, sel) {
    root = root || document;
    var list = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (root.matches && root.matches(sel)) list.unshift(root);
    return list;
  }

  function show(el) { el.classList.add('is-visible'); }

  // Rejoue l'animation : retour à l'état caché, puis révélation deux frames plus tard.
  // Filet de sécurité : l'élément est forcé visible après 900 ms quoi qu'il arrive.
  function replay(el) {
    el.classList.remove('is-visible');
    void el.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { show(el); });
    });
    setTimeout(function () { show(el); }, 900);
  }

  function getObserver() {
    if (io || typeof IntersectionObserver === 'undefined') return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    return io;
  }

  // En mode éditeur, on n'attend pas le scroll : tout est animé puis laissé visible.
  function initReveal(root) {
    var obs = getObserver();
    qsa(root, '[data-reveal]').forEach(function (el) {
      if (designMode) { replay(el); return; }
      if (obs) obs.observe(el); else show(el);
    });
  }

  function revealAll(root) { qsa(root, '[data-reveal]').forEach(show); }

  var updateSticky = function () {};
  function initSticky() {
    var bar = document.getElementById('laev-stickybar');
    if (!bar) return;
    var last = null;
    updateSticky = function () {
      var trigger = document.querySelector('[data-hero-trigger]');
      var showBar = trigger ? trigger.getBoundingClientRect().bottom < 64 : true;
      if (showBar !== last) {
        last = showBar;
        bar.style.transform = showBar ? 'translateY(0)' : 'translateY(-100%)';
        if (showBar) bar.classList.add('is-visible'); else bar.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', function () { updateSticky(); }, { passive: true });
    updateSticky();
  }

  // Vidéos : celles marquées data-lazy-src ne sont téléchargées que lorsqu'elles approchent de l'écran.
  function initVideos(root) {
    qsa(root, 'video').forEach(function (v) {
      if (v.dataset.laevInit) return;
      v.dataset.laevInit = '1';
      v.muted = true; v.defaultMuted = true; v.loop = true;
      v.setAttribute('muted', ''); v.setAttribute('loop', '');
      v.setAttribute('playsinline', ''); v.setAttribute('autoplay', '');
      var lazy = !!v.dataset.lazySrc;
      var tryPlay = function () {
        try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      };
      var load = function () {
        if (lazy && !v.getAttribute('src')) { v.src = v.dataset.lazySrc; v.load(); }
      };
      v.addEventListener('canplay', tryPlay);
      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { load(); tryPlay(); } else { try { v.pause(); } catch (err) {} }
          });
        }, { threshold: 0.01, rootMargin: '0px 300px 0px 300px' }).observe(v);
      } else {
        load();
        tryPlay();
      }
      if (!lazy) tryPlay();
    });
  }

  window.laevSubscribe = function () {
    var inp = document.getElementById('laev-email');
    var form = document.getElementById('laev-email-form');
    var success = document.getElementById('laev-email-success');
    if (!inp || !inp.value || inp.value.indexOf('@') < 1) { if (inp) { inp.focus(); inp.style.borderColor = 'var(--cream)'; } return; }
    if (form) form.style.display = 'none';
    if (success) success.style.display = 'flex';
  };

  // Éditeur de thème : une section rechargée arrive avec des éléments neufs, sans la classe is-visible.
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initVideos(e.target);
    updateSticky();
  });
  document.addEventListener('shopify:section:select', function (e) { revealAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var section = (e.target.closest && e.target.closest('.shopify-section')) || e.target;
    revealAll(section);
  });

  function boot() {
    initReveal(document);
    initSticky();
    initVideos(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();